/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentClassRoomRequest } from './AppointmentClassRoomRequest';
import {
    AppointmentClassRoomRequestFromJSON,
    AppointmentClassRoomRequestFromJSONTyped,
    AppointmentClassRoomRequestToJSON,
    AppointmentClassRoomRequestToJSONTyped,
} from './AppointmentClassRoomRequest';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { AppointmentVariantRequest } from './AppointmentVariantRequest';
import {
    AppointmentVariantRequestFromJSON,
    AppointmentVariantRequestFromJSONTyped,
    AppointmentVariantRequestToJSON,
    AppointmentVariantRequestToJSONTyped,
} from './AppointmentVariantRequest';
import type { PriceType } from './PriceType';
import {
    PriceTypeFromJSON,
    PriceTypeFromJSONTyped,
    PriceTypeToJSON,
    PriceTypeToJSONTyped,
} from './PriceType';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateAppointmentRequest
 */
export interface CreateAppointmentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequest
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequest
     */
    onlineMeetingUrl: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof CreateAppointmentRequest
     */
    appointmentTypeId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequest
     */
    duration: string;
    /**
     * 
     * @type {number}
     * @memberof CreateAppointmentRequest
     */
    payRate: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAppointmentRequest
     */
    price: number;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof CreateAppointmentRequest
     */
    maxNumberOfStudents: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAppointmentRequest
     */
    allowOnlineBooking: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAppointmentRequest
     */
    allowCancellation: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequest
     */
    bookingNotice: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentRequest
     */
    cancellationNotice: string | null;
    /**
     * 
     * @type {any}
     * @memberof CreateAppointmentRequest
     */
    startDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof CreateAppointmentRequest
     */
    endDate: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateAppointmentRequest
     */
    teacherId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAppointmentRequest
     */
    requirePayment: boolean;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateAppointmentRequest
     */
    slotIntervalMinutes: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {PriceType}
     * @memberof CreateAppointmentRequest
     */
    priceType: PriceType;
    /**
     * 
     * @type {Array<AppointmentClassRoomRequest>}
     * @memberof CreateAppointmentRequest
     */
    classRooms?: Array<AppointmentClassRoomRequest> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAppointmentRequest
     */
    isApprovalRequired?: boolean | null;
    /**
     * 
     * @type {Array<AppointmentVariantRequest>}
     * @memberof CreateAppointmentRequest
     */
    variants?: Array<AppointmentVariantRequest> | null;
}



/**
 * Check if a given object implements the CreateAppointmentRequest interface.
 */
export function instanceOfCreateAppointmentRequest(value: object): value is CreateAppointmentRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('onlineMeetingUrl' in value) || value['onlineMeetingUrl'] === undefined) return false;
    if (!('appointmentTypeId' in value) || value['appointmentTypeId'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('payRate' in value) || value['payRate'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('maxNumberOfStudents' in value) || value['maxNumberOfStudents'] === undefined) return false;
    if (!('allowOnlineBooking' in value) || value['allowOnlineBooking'] === undefined) return false;
    if (!('allowCancellation' in value) || value['allowCancellation'] === undefined) return false;
    if (!('bookingNotice' in value) || value['bookingNotice'] === undefined) return false;
    if (!('cancellationNotice' in value) || value['cancellationNotice'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('teacherId' in value) || value['teacherId'] === undefined) return false;
    if (!('requirePayment' in value) || value['requirePayment'] === undefined) return false;
    if (!('slotIntervalMinutes' in value) || value['slotIntervalMinutes'] === undefined) return false;
    if (!('priceType' in value) || value['priceType'] === undefined) return false;
    return true;
}

export function CreateAppointmentRequestFromJSON(json: any): CreateAppointmentRequest {
    return CreateAppointmentRequestFromJSONTyped(json, false);
}

export function CreateAppointmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAppointmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'onlineMeetingUrl': json['onlineMeetingUrl'],
        'appointmentTypeId': ActorActivityRecordActorUserIdFromJSON(json['appointmentTypeId']),
        'duration': json['duration'],
        'payRate': json['payRate'],
        'price': json['price'],
        'maxNumberOfStudents': ActorActivityRecordActorUserIdFromJSON(json['maxNumberOfStudents']),
        'allowOnlineBooking': json['allowOnlineBooking'],
        'allowCancellation': json['allowCancellation'],
        'bookingNotice': json['bookingNotice'],
        'cancellationNotice': json['cancellationNotice'],
        'startDate': json['startDate'],
        'endDate': json['endDate'],
        'teacherId': ApiUserTasksGetPageParameterFromJSON(json['teacherId']),
        'requirePayment': json['requirePayment'],
        'slotIntervalMinutes': ApiUserTasksGetPageParameterFromJSON(json['slotIntervalMinutes']),
        'priceType': PriceTypeFromJSON(json['priceType']),
        'classRooms': json['classRooms'] == null ? undefined : ((json['classRooms'] as Array<any>).map(AppointmentClassRoomRequestFromJSON)),
        'isApprovalRequired': json['isApprovalRequired'] == null ? undefined : json['isApprovalRequired'],
        'variants': json['variants'] == null ? undefined : ((json['variants'] as Array<any>).map(AppointmentVariantRequestFromJSON)),
    };
}

export function CreateAppointmentRequestToJSON(json: any): CreateAppointmentRequest {
    return CreateAppointmentRequestToJSONTyped(json, false);
}

export function CreateAppointmentRequestToJSONTyped(value?: CreateAppointmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'onlineMeetingUrl': value['onlineMeetingUrl'],
        'appointmentTypeId': ActorActivityRecordActorUserIdToJSON(value['appointmentTypeId']),
        'duration': value['duration'],
        'payRate': value['payRate'],
        'price': value['price'],
        'maxNumberOfStudents': ActorActivityRecordActorUserIdToJSON(value['maxNumberOfStudents']),
        'allowOnlineBooking': value['allowOnlineBooking'],
        'allowCancellation': value['allowCancellation'],
        'bookingNotice': value['bookingNotice'],
        'cancellationNotice': value['cancellationNotice'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'teacherId': ApiUserTasksGetPageParameterToJSON(value['teacherId']),
        'requirePayment': value['requirePayment'],
        'slotIntervalMinutes': ApiUserTasksGetPageParameterToJSON(value['slotIntervalMinutes']),
        'priceType': PriceTypeToJSON(value['priceType']),
        'classRooms': value['classRooms'] == null ? undefined : ((value['classRooms'] as Array<any>).map(AppointmentClassRoomRequestToJSON)),
        'isApprovalRequired': value['isApprovalRequired'],
        'variants': value['variants'] == null ? undefined : ((value['variants'] as Array<any>).map(AppointmentVariantRequestToJSON)),
    };
}

